(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9603],{

/***/ 32252:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(98285);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _public_icons_filter_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24495);
/* harmony import */ var _public_icons_arrow_up_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97274);
/* harmony import */ var _public_icons_grid_on_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7520);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18216);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47956);







const PLPLoader = (props)=>{
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const [rowCols, setRowCols] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setRowCols(width < _constants_index__WEBPACK_IMPORTED_MODULE_6__.ROW_COLUMN_MIN_WIDTH ? 2 : 3);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "product-listing",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-listing__sticky-nav-wrap",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: " ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container-fluid product-listing__sticky-nav false",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "product-listing__row",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "container kf-react-plp-container",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-listing__row",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "product-listing__col product-listing__controls",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    className: "product-listing__total shimmer-loading__para30 shimmer width-240"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                                    className: "sorting-section",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "product-listing__fillter_sort",
                                                            children: "Filter & Sort"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                            id: "showFilter",
                                                            "aria-label": "Show Filters",
                                                            className: "product-listing__filter-toggle gbh-data-layer",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                    className: "product-listing__filter-toggle-text  product-listing__filter-toggle-text--show hideMobile\n                            }",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            className: "show",
                                                                            children: "Hide Filters"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            className: "hide",
                                                                            children: "Hide Filters"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: _public_icons_filter_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                                                                    className: "product-listing__filter-toggle-icon",
                                                                    alt: "Toggle Filter"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "product-listing__grid-control",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "d-block d-sm-none",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    className: "product-listing__grid-control-icon",
                                                                    src: _public_icons_grid_on_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                                                    alt: "grid on"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "sort",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                                    className: "sort__toggle",
                                                                    tabIndex: "0",
                                                                    "aria-label": "Featured selected",
                                                                    children: [
                                                                        "Sort By: Featured",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            src: _public_icons_arrow_up_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                                                                            alt: "Sort",
                                                                            className: "sort__toggle-icon",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                    className: "sort__drop-down",
                                                                    "aria-label": "Sort By Button Closed",
                                                                    "aria-hidden": "true",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            id: "select-options-0",
                                                                            role: "option",
                                                                            tabIndex: "-1",
                                                                            "aria-selected": "true",
                                                                            className: "sort__item gbh-data-layer active",
                                                                            children: "Featured"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            id: "select-options-1",
                                                                            role: "option",
                                                                            tabIndex: "-1",
                                                                            "aria-selected": "false",
                                                                            className: "sort__item gbh-data-layer ",
                                                                            children: "Price: High - Low"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            id: "select-options-2",
                                                                            role: "option",
                                                                            tabIndex: "-1",
                                                                            "aria-selected": "false",
                                                                            className: "sort__item gbh-data-layer ",
                                                                            children: "Price: Low - High"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            id: "select-options-3",
                                                                            role: "option",
                                                                            tabIndex: "-1",
                                                                            "aria-selected": "false",
                                                                            className: "sort__item gbh-data-layer ",
                                                                            children: "A - Z"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            id: "select-options-4",
                                                                            role: "option",
                                                                            tabIndex: "-1",
                                                                            "aria-selected": "false",
                                                                            className: "sort__item gbh-data-layer ",
                                                                            children: "Z - A"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "product-listing kf-react-plp-container product-listing__tiles",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-listing__row",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col product-listing__tile-col product-listing__tile-col--full-width",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "product-listing__filter borderNone",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "filter__inner-container shimmer height-300"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "filter__footer",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "products-per-page width-240 mt60 mb20",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "shimmer-loading__headpara shimmer"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "products-per-page width-100",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "shimmer-loading__para shimmer"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "product-listing__tile-col",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "product-listing__row row-cols-".concat(rowCols),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: " product-listing__tile product-listing__col px-1 ",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "product-listing__row",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper ",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "product-listing__col px-1 product-listing__tile",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lazyload-wrapper",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "product-tile",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-list-tile__image wow ",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "shimmer-loading__image shimmer"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "product-tile__details",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "width-full",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-170 mt60 "
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer mb20 width-full"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer width-100"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PLPLoader);


/***/ }),

/***/ 98285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 18 modules
var esm = __webpack_require__(72433);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./components/AemGrid.jsx + 107 modules
var AemGrid = __webpack_require__(3939);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/utils/cart.js
var cart = __webpack_require__(87292);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./src/hooks/usePageAuth.js
var usePageAuth = __webpack_require__(85614);
// EXTERNAL MODULE: ./src/store/features/cartSlice.js
var cartSlice = __webpack_require__(64925);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageHeader.jsx + 31 modules
var GlobalPageHeader = __webpack_require__(82660);
// EXTERNAL MODULE: ./components/Shared/GlobalPage/GlobalPageFooter.jsx
var GlobalPageFooter = __webpack_require__(10884);
// EXTERNAL MODULE: ./src/components/Shared/GlobalPage/GlobalPageLayout.jsx
var GlobalPageLayout = __webpack_require__(82706);
;// CONCATENATED MODULE: ./src/components/Search/v1/SearchProgressive/index.jsx


const SearchProgressive = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "search-result",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-fluid",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "search-result__tab-header",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container search-result__tab-buttons",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "search-result__tab-button gbh-data-layer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__button shimmer"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "search-result__tab-button gbh-data-layer ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__button shimmer"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "search-result__tab-button gbh-data-layer ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__button shimmer"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "search-result__tab-button gbh-data-layer ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "shimmer-loading__button shimmer"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "search-result__tab-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container product-list__container product-list__tiles",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-list__filter borderNone",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "filter__inner-container shimmer height-300"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "filter__footer",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "products-per-page width-240 mt60 mb20",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__headpara shimmer"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "products-per-page width-100",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "shimmer-loading__para shimmer"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-list__tile-col",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "row row-cols-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col px-1 product-list__tile",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "kf-lazyload-wrapper ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "product-tile",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "product-tile__image",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "shimmer-loading__image shimmer"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "product-tile__details",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "width-full",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "width-full",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "product-tile__details product-tile__compare-main",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "product-tile__colors",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "product-tile__colors--count d-none d-lg-block",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col px-1 product-list__tile",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "kf-lazyload-wrapper ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "product-tile",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "product-tile__image",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "shimmer-loading__image shimmer"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "product-tile__details",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "width-full",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "width-full",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "product-tile__details product-tile__compare-main",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "product-tile__colors",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "product-tile__colors--count d-none d-lg-block",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "col px-1 product-list__tile",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "kf-lazyload-wrapper ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "product-tile",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "product-tile__image",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "shimmer-loading__image shimmer"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "product-tile__details",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "width-full",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "width-full",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "shimmer-loading__para shimmer width-full"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "product-tile__details product-tile__compare-main",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "product-tile__colors",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "product-tile__colors--count d-none d-lg-block",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                className: "shimmer-loading__para shimmer width-full"
                                                                                            })
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var v1_SearchProgressive = (SearchProgressive);

;// CONCATENATED MODULE: ./public/icons/Close Icon.svg
/* harmony default export */ var Close_Icon = ({"src":"/_next/static/media/Close Icon.b99aaae5.svg","height":17,"width":17});
// EXTERNAL MODULE: ./src/components/Search/v1/SearchView/index.module.scss
var index_module = __webpack_require__(42680);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/components/Default/DynamicSearch/v1/SearchPanel/localization.js
var localization = __webpack_require__(55631);
// EXTERNAL MODULE: ./src/i18n/useSearchi18n.js
var useSearchi18n = __webpack_require__(31090);
;// CONCATENATED MODULE: ./components/Search/v1/OuterSearchProgressive/index.jsx








const OuterSearchProgressive = ()=>{
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const staticText = (0,useSearchi18n/* default */.Z)({});
    const [staticTexts] = (0,react.useState)((0,localization/* getTranslations */.F)(t));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()) === null || (index_module_default()) === void 0 ? void 0 : (index_module_default()).searchViewStyleWrapper, " Plp-Search"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "search-result",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container-fluid",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-listing__row no-gutters",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-listing__col search-result__breadcrumb-header --no-results",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "search-result__breadcrumb kf-react-plp-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                            role: "list",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                    role: "listitem",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "#",
                                                            children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.globalHome
                                                        }),
                                                        " / "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    role: "listitem",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: "#",
                                                        children: staticText === null || staticText === void 0 ? void 0 : staticText.searchResults
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "search-result__header search-result--no-background",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "kf-react-plp-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "search-result__search-header",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "search-result__description",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        role: "alert",
                                                        "aria-live": "polite",
                                                        className: "search-result__showing --no-results",
                                                        children: [
                                                            staticText === null || staticText === void 0 ? void 0 : staticText.loading,
                                                            " ",
                                                            staticText === null || staticText === void 0 ? void 0 : staticText.results
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "search-result__search-field",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            id: "search_close_button",
                                                            className: "search-result__search-control",
                                                            autoFocus: true,
                                                            placeholder: "Search Annsacks"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "search-result__close-button",
                                                            role: "button",
                                                            tabIndex: "0",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                src: Close_Icon === null || Close_Icon === void 0 ? void 0 : Close_Icon.src,
                                                                alt: "close-icon"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SearchProgressive, {})
                ]
            })
        })
    });
};
/* harmony default export */ var v1_OuterSearchProgressive = (OuterSearchProgressive);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./constants/index.js + 2 modules
var constants = __webpack_require__(47956);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./src/store/features/searchSlice.js
var searchSlice = __webpack_require__(54127);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/Search/v1/SearchView/index.jsx









const PopularSearch = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4267), __webpack_require__.e(732)]).then(__webpack_require__.bind(__webpack_require__, 20732)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(20732)
            ]
    }
});
const NoResultLinks = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4267), __webpack_require__.e(350)]).then(__webpack_require__.bind(__webpack_require__, 40350)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(40350)
            ]
    }
});


const SearchComponentView = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19;
    const { data , brand ="" , loadPopularSearch , activeTabVal , tabList , searchKeyword , staticTexts , totalResults , onSearch , loading , handleSearchEnter , searchResponse  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const searchRef = (0,react.useRef)(null);
    const newState = (0,es/* useSelector */.v9)(searchSlice/* searchState */.uv);
    const { noResultPopularTopicsHeading ="" , noResultPopularLinks =[] , noResultOurSuggestionsHeading ="" , noResultOurSuggestionsSubcopy =""  } = data;
    const [activeTab, setActiveTab] = (0,react.useState)(activeTabVal ? activeTabVal < 0 ? 0 : activeTabVal : 0);
    const [homePagePath, setHomePagePath] = (0,react.useState)("");
    const [searchPlaceholder, setSearchplaceholder] = (0,react.useState)(brand);
    const [oldTotalResults, setOldTotalResults] = (0,react.useState)(totalResults);
    let isSpellTagged = false;
    let resultsText = "";
    let keepSearching = "";
    const urlParams = new URL(window.location.href);
    let keyword = urlParams === null || urlParams === void 0 ? void 0 : (ref = urlParams.searchParams) === null || ref === void 0 ? void 0 : ref.get("keyword");
    try {
        var ref20, ref21;
        keyword = (urlParams === null || urlParams === void 0 ? void 0 : (ref20 = urlParams.searchParams) === null || ref20 === void 0 ? void 0 : ref20.get("keyword")) ? decodeURIComponent(urlParams === null || urlParams === void 0 ? void 0 : (ref21 = urlParams.searchParams) === null || ref21 === void 0 ? void 0 : ref21.get("keyword")) : "";
    } catch (error) {
        console.error("URIError: malformed URI sequence");
    }
    let currTab = activeTab ? Number(activeTab) : 0 // reqired for ADA focus
    ;
    const setCount = ()=>{
        const counts = {};
        tabList === null || tabList === void 0 ? void 0 : tabList.forEach((tab)=>{
            var ref;
            counts[tab === null || tab === void 0 ? void 0 : tab.id] = {
                count: tab === null || tab === void 0 ? void 0 : tab.count
            };
            if (searchKeyword !== (newState === null || newState === void 0 ? void 0 : (ref = newState.searchDetails) === null || ref === void 0 ? void 0 : ref.keyword)) {
                dispatch((0,searchSlice/* setSearchFilter */.Qf)({
                    queries: [],
                    key: tab === null || tab === void 0 ? void 0 : tab.id
                }));
            }
        });
        dispatch((0,searchSlice/* setSearchCount */.kj)(counts));
    };
    (0,react.useEffect)(()=>{
        // Will trigger only when tab keyword is available in url.
        if (activeTabVal != undefined) {
            setActiveTab(activeTabVal);
        }
    }, [
        activeTabVal
    ]);
    (0,react.useEffect)(()=>{
        var ref;
        (ref = (0,config/* getConfig */.i)()) === null || ref === void 0 ? void 0 : ref.then((config)=>{
            var ref, ref1, ref2;
            var ref3;
            const searchBrandPlaceholder = (ref3 = config === null || config === void 0 ? void 0 : (ref = config.apiEndPointData) === null || ref === void 0 ? void 0 : ref.searchBrandPlaceholder) !== null && ref3 !== void 0 ? ref3 : brand;
            if ((searchBrandPlaceholder === null || searchBrandPlaceholder === void 0 ? void 0 : searchBrandPlaceholder.length) > 0) {
                setSearchplaceholder(searchBrandPlaceholder);
            }
            var ref4;
            (ref2 = (0,helper/* getShortenedUrl */.Ppy)((ref4 = config === null || config === void 0 ? void 0 : (ref1 = config.general) === null || ref1 === void 0 ? void 0 : ref1.homepageUrl) !== null && ref4 !== void 0 ? ref4 : "/")) === null || ref2 === void 0 ? void 0 : ref2.then((res)=>setHomePagePath(res));
        });
        setCount();
    }, []);
    (0,react.useEffect)(()=>{
        if (loading) {
            setCount();
            setActiveTab(0);
        }
    }, [
        searchKeyword,
        loading
    ]);
    (0,react.useEffect)(()=>{
        if (activeTab < 0) {
            setActiveTab(0);
        }
        if ((tabList === null || tabList === void 0 ? void 0 : tabList.length) <= (activeTab ? Number(activeTab) : 0)) {
            setActiveTab(0);
        }
    });
    if ((searchResponse === null || searchResponse === void 0 ? void 0 : (ref1 = searchResponse.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fusion) === null || ref2 === void 0 ? void 0 : ref2.tagger) && (searchResponse === null || searchResponse === void 0 ? void 0 : (ref3 = searchResponse.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fusion) === null || ref4 === void 0 ? void 0 : ref4.tagger[0]) && ((ref7 = searchResponse === null || searchResponse === void 0 ? void 0 : (ref5 = searchResponse.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fusion) === null || ref6 === void 0 ? void 0 : ref6.tagger[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.tag) === null || ref8 === void 0 ? void 0 : ref8.type) === "spell") {
        var ref22, ref23, ref24, ref25, ref26, ref27;
        isSpellTagged = true;
        keepSearching = (ref24 = searchResponse === null || searchResponse === void 0 ? void 0 : (ref22 = searchResponse.data) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.fusion) === null || ref23 === void 0 ? void 0 : ref23.tagger[0]) === null || ref24 === void 0 ? void 0 : ref24.surfaceForm;
        resultsText = "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.showing, " ").concat(totalResults === null || totalResults === void 0 ? void 0 : totalResults.toLocaleString(), " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.results, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.for, ' "').concat((ref27 = searchResponse === null || searchResponse === void 0 ? void 0 : (ref25 = searchResponse.data) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.fusion) === null || ref26 === void 0 ? void 0 : ref26.tagger[0]) === null || ref27 === void 0 ? void 0 : ref27.outputForms[0], '"');
    } else if ((searchResponse === null || searchResponse === void 0 ? void 0 : (ref9 = searchResponse.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.fusion) === null || ref10 === void 0 ? void 0 : ref10.autoCorrectQuery) && (searchResponse === null || searchResponse === void 0 ? void 0 : (ref11 = searchResponse.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.fusion) === null || ref12 === void 0 ? void 0 : ref12.org_q)) {
        var ref28, ref29, ref30, ref31;
        isSpellTagged = true;
        keepSearching = searchResponse === null || searchResponse === void 0 ? void 0 : (ref28 = searchResponse.data) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.fusion) === null || ref29 === void 0 ? void 0 : ref29.org_q;
        resultsText = "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.showing, " ").concat(totalResults === null || totalResults === void 0 ? void 0 : totalResults.toLocaleString(), " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.results, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.for, ' "').concat((searchKeyword === null || searchKeyword === void 0 ? void 0 : searchKeyword.length) < 3 ? keyword : searchResponse === null || searchResponse === void 0 ? void 0 : (ref30 = searchResponse.data) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.fusion) === null || ref31 === void 0 ? void 0 : ref31.autoCorrectQuery, '"');
    } else {
        resultsText = "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.showing, " ").concat(totalResults === null || totalResults === void 0 ? void 0 : totalResults.toLocaleString(), " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.results, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.for, ' "').concat((searchKeyword === null || searchKeyword === void 0 ? void 0 : searchKeyword.length) < 3 ? keyword : searchKeyword, '"');
    }
    const changeTab = (tab)=>{
        var ref, ref1, ref2;
        const query = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.search;
        const currentTab = tabList[tab];
        if (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("SRPTabDetails")) {
            var ref3;
            const srpTabDetails = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("SRPTabDetails"));
            const url = srpTabDetails[currentTab === null || currentTab === void 0 ? void 0 : currentTab.id];
            if (url) history === null || history === void 0 ? void 0 : history.replaceState(window === null || window === void 0 ? void 0 : (ref3 = window.location) === null || ref3 === void 0 ? void 0 : ref3.pathname, document === null || document === void 0 ? void 0 : document.title, url);
            else (0,helper/* resetUrl */.eRK)();
        } else if (query) (0,helper/* resetUrl */.eRK)();
        if ((newState === null || newState === void 0 ? void 0 : (ref1 = newState.searchDetails) === null || ref1 === void 0 ? void 0 : ref1.keyword) && (newState === null || newState === void 0 ? void 0 : (ref2 = newState.searchDetails) === null || ref2 === void 0 ? void 0 : ref2.keyword) !== searchKeyword) {
            setCount();
        }
        if (searchKeyword === "") {
            var ref4;
            const urlParams = new URLSearchParams(window === null || window === void 0 ? void 0 : (ref4 = window.location) === null || ref4 === void 0 ? void 0 : ref4.search);
            const keyword = urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("keyword");
            onSearch(keyword);
        }
        setActiveTab(tab);
    };
    const handleClose = function() {
        let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        setOldTotalResults(value);
        onSearch("", false);
        const input = document.getElementById("search_close_button");
        input === null || input === void 0 ? void 0 : input.focus();
    };
    const handleKeyPress = (e)=>{
        if (e.keyCode === 37 || e.keyCode === 39) {
            var ref, ref1;
            if (e.keyCode === 37) {
                currTab = currTab - 1;
            } else if (e.keyCode === 39) {
                currTab = currTab + 1;
            }
            if (currTab < 0) currTab = (tabList === null || tabList === void 0 ? void 0 : tabList.length) - 1;
            if (currTab >= (tabList === null || tabList === void 0 ? void 0 : tabList.length)) currTab = 0;
            (ref1 = document.getElementById("".concat((ref = tabList[currTab]) === null || ref === void 0 ? void 0 : ref.title, "-tab"))) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    };
    const searchBoxEventInfo = (type)=>{
        var ref;
        if (searchRef === null || searchRef === void 0 ? void 0 : (ref = searchRef.current) === null || ref === void 0 ? void 0 : ref.value) {
            return JSON.stringify({
                eventAction: "search:search box:" + type,
                eventName: "search:search box:" + type,
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: type,
                internalLinkPosition: "search",
                internalLinkType: "search:".concat(keyword),
                internalLinkZoneName: "search:search box",
                internalLinkURL: "n/a",
                clickInternalLinks: "true",
                searchTerm: keyword,
                searchResult: oldTotalResults
            });
        }
    };
    const breadcrumbEventInfo = (type)=>{
        var ref;
        const homeBreadcrumb = (type === null || type === void 0 ? void 0 : type.toLowerCase()) === "home";
        return JSON.stringify({
            eventAction: "search:breadcrumb",
            eventName: "search:breadcrumb",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: homeBreadcrumb ? "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.home) : "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.home, " > ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.searchResults),
            internalLinkPosition: "search",
            internalLinkType: "search:breadcrumb",
            internalLinkZoneName: "search:search box",
            internalLinkURL: homeBreadcrumb ? "".concat(homePagePath) : "".concat(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href),
            clickInternalLinks: "true"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((index_module_default()) === null || (index_module_default()) === void 0 ? void 0 : (index_module_default()).searchViewStyleWrapper, " Plp-Search"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "search-result",
                id: "searchWrapperId",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container-fluid",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-listing__row no-gutters",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-listing__col search-result__breadcrumb-header ".concat(totalResults === 0 ? " --no-results" : ""),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "search-result__breadcrumb kf-react-plp-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                                            "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : (ref13 = staticTexts.ariaLabel) === null || ref13 === void 0 ? void 0 : ref13.breadcrumb,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                                role: "list",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                        role: "listitem",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                "aria-label": "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.home, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : (ref14 = staticTexts.ariaLabel) === null || ref14 === void 0 ? void 0 : ref14.page),
                                                                className: "gbh-data-layer",
                                                                "data-gbh-data-layer": breadcrumbEventInfo(staticTexts === null || staticTexts === void 0 ? void 0 : (ref15 = staticTexts.home) === null || ref15 === void 0 ? void 0 : ref15.trim()),
                                                                href: homePagePath,
                                                                children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.home
                                                            }),
                                                            " / "
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        role: "listitem",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            "aria-label": (staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.searchResults) + " " + (staticTexts === null || staticTexts === void 0 ? void 0 : (ref16 = staticTexts.ariaLabel) === null || ref16 === void 0 ? void 0 : ref16.page),
                                                            className: "gbh-data-layer",
                                                            "aria-current": staticTexts === null || staticTexts === void 0 ? void 0 : (ref17 = staticTexts.ariaLabel) === null || ref17 === void 0 ? void 0 : ref17.page,
                                                            "data-gbh-data-layer": breadcrumbEventInfo(staticTexts === null || staticTexts === void 0 ? void 0 : (ref18 = staticTexts.searchResults) === null || ref18 === void 0 ? void 0 : ref18.trim()),
                                                            href: "#",
                                                            children: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.searchResults
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "search-result__header ".concat(loading || !totalResults ? "search-result--no-background" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "kf-react-plp-container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "search-result__search-header",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "search-result__description",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                role: "alert",
                                                                "aria-live": "polite",
                                                                className: "search-result__showing ".concat(totalResults === 0 ? " --no-results" : ""),
                                                                children: loading ? "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.loading, " ").concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.results) : totalResults === 0 ? staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.noResults : /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                    children: resultsText
                                                                })
                                                            }),
                                                            !loading && isSpellTagged === true && (searchKeyword === null || searchKeyword === void 0 ? void 0 : searchKeyword.length) > 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "search-result__instead",
                                                                children: [
                                                                    staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.searchInstead,
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        onClick: ()=>onSearch(keepSearching, true, true),
                                                                        children: keepSearching
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "search-result__search-field",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                ref: searchRef,
                                                                type: "text",
                                                                id: "search_close_button",
                                                                className: "search-result__search-control",
                                                                value: searchKeyword,
                                                                onChange: (e)=>{
                                                                    var ref;
                                                                    return onSearch(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                                                },
                                                                onKeyDown: (e)=>(e.key === "Enter" || e.keyCode === 13) && handleSearchEnter(),
                                                                autoFocus: true,
                                                                placeholder: "".concat(staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.searchBrand, " ").concat(searchPlaceholder)
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "search-result__close-button".concat(keyword ? " gbh-data-layer" : ""),
                                                                role: "button",
                                                                tabIndex: "0",
                                                                "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : (ref19 = staticTexts.ariaLabel) === null || ref19 === void 0 ? void 0 : ref19.close,
                                                                "data-gbh-data-layer": searchBoxEventInfo("close"),
                                                                onClick: ()=>handleClose(totalResults),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: Close_Icon === null || Close_Icon === void 0 ? void 0 : Close_Icon.src,
                                                                    alt: "close-icon"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_SearchProgressive, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row no-gutters",
                            children: !loading && (totalResults > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "search-result__tab-header",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "container search-result__tab-buttons kf-react-container",
                                            role: "tablist",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "d-flex",
                                                children: tabList === null || tabList === void 0 ? void 0 : tabList.map((tab, i)=>{
                                                    var ref, ref1, ref2;
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        id: "".concat(tab === null || tab === void 0 ? void 0 : tab.title, "-tab"),
                                                        "aria-label": staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.ariaLabel) === null || ref === void 0 ? void 0 : ref.tabs((ref1 = newState === null || newState === void 0 ? void 0 : newState.searchDetails[tab === null || tab === void 0 ? void 0 : tab.id]) === null || ref1 === void 0 ? void 0 : ref1.count, tab === null || tab === void 0 ? void 0 : tab.title),
                                                        "aria-selected": (activeTab ? Number(activeTab) : 0) === i ? true : false,
                                                        role: "tab",
                                                        "data-gbh-data-layer": '{"eventAction":"search results:hero:inner tabs","eventName":"search results:hero:inner tabs","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"'.concat(tab === null || tab === void 0 ? void 0 : tab.title, '","internalLinkPosition":"search","internalLinkType":"search results:navigation","internalLinkZoneName":"search results:hero","internalLinkURL":"n/a","clickInternalLinks":"true"}'),
                                                        className: "search-result__tab-button gbh-data-layer ".concat((activeTab ? Number(activeTab) : 0) === i ? "--active" : ""),
                                                        onClick: ()=>changeTab(i),
                                                        onKeyDown: (e)=>handleKeyPress(e),
                                                        tabIndex: (activeTab ? Number(activeTab) : 0) === i ? 0 : -1,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            role: "heading",
                                                            "aria-level": "2",
                                                            children: "".concat(tab === null || tab === void 0 ? void 0 : tab.title, " (").concat(tab === null || tab === void 0 ? void 0 : (ref2 = tab.count) === null || ref2 === void 0 ? void 0 : ref2.toLocaleString(), ")")
                                                        })
                                                    }, i);
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "search-result__tab-content",
                                        children: get_default()(tabList[activeTab ? Number(activeTab) : 0], "content", "")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "search-result__no-result",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-lg-4 col-sm-12 search-result__no-result-column",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "search-result__suggestions-title wow animate__slideInLeft",
                                                        children: noResultOurSuggestionsHeading
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "search-result__suggestions-list wow animate__fadeInUp",
                                                        children: (0,helper/* sanitizeInnerHtml */.KD0)(noResultOurSuggestionsSubcopy)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-4 col-sm-12 search-result__no-result-column",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularSearch, {
                                                    staticTexts: staticTexts,
                                                    loadPopularSearch: loadPopularSearch,
                                                    brand: brand,
                                                    updateFromResult: onSearch,
                                                    staticData: data
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-lg-4 col-sm-12 search-result__no-result-column",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResultLinks, {
                                                    data: noResultPopularLinks,
                                                    link: true,
                                                    heading: noResultPopularTopicsHeading
                                                })
                                            })
                                        ]
                                    })
                                })
                            }))
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var SearchView = (SearchComponentView);

// EXTERNAL MODULE: ./components/Search/v1/InspirationTab/index.jsx
var InspirationTab = __webpack_require__(40577);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-lazy-load/dist/LazyLoad.js
var LazyLoad = __webpack_require__(25043);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./src/store/features/productListSlice.js
var productListSlice = __webpack_require__(42286);
// EXTERNAL MODULE: ./src/store/features/authSlice.js
var authSlice = __webpack_require__(2693);
// EXTERNAL MODULE: ./src/hooks/usePrevious.js
var usePrevious = __webpack_require__(97349);
// EXTERNAL MODULE: ./components/Search/v1/ProductsTab/helper.js
var ProductsTab_helper = __webpack_require__(34955);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./src/components/Search/v1/TechnicalTile/index.jsx + 2 modules
var TechnicalTile = __webpack_require__(24719);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Filter/index.jsx + 3 modules
var Filter = __webpack_require__(61304);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/Pagination/index.jsx
var Pagination = __webpack_require__(57633);
// EXTERNAL MODULE: ./components/ProductList/v2/ProductListView/StickyNav/stickyNavHeader.jsx + 1 modules
var stickyNavHeader = __webpack_require__(79378);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductListView/index.module.scss
var ProductListView_index_module = __webpack_require__(55266);
var ProductListView_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductListView_index_module);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Sort/index.module.scss
var Sort_index_module = __webpack_require__(58088);
var Sort_index_module_default = /*#__PURE__*/__webpack_require__.n(Sort_index_module);
// EXTERNAL MODULE: ./src/components/ProductList/v2/Filter/index.module.scss
var Filter_index_module = __webpack_require__(68167);
var Filter_index_module_default = /*#__PURE__*/__webpack_require__.n(Filter_index_module);
;// CONCATENATED MODULE: ./src/components/Search/v1/TechnicalTab/index.jsx
























const TechnicalTab = (props)=>{
    var ref;
    const { totalResults =0 , searchKeyword ="" , displayPrint , displayShare , page ="" , staticTexts ={} , onSearch =()=>{} , productsPerPage , type ="" , marketParamValues =[]  } = props;
    const [width] = (0,useWindowResize/* default */.Z)();
    const dispatch = (0,es/* useDispatch */.I0)();
    const { isLandscape  } = props;
    const [showFilter, setShowFilter] = (0,react.useState)(width >= 1024 ? true : false);
    const [rowCols, setRowCols] = (0,react.useState)(width < 1024 ? 1 : 3);
    const [curRows, setCurRows] = (0,react.useState)(30);
    const [start, setStart] = (0,react.useState)(0);
    const filterModalWindow = (0,react.useRef)(null);
    const [selectedSort, setSelectedSort] = (0,react.useState)({});
    const [filterQueries, setFilterQueries] = (0,react.useState)([]);
    const [siteName, setSiteName] = (0,react.useState)();
    const [dataPopulated, setDataPopulated] = (0,react.useState)(false);
    var ref1;
    const [scrollToSku, setScrollToSku] = (0,react.useState)((ref1 = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.plpScrollSku) !== null && ref1 !== void 0 ? ref1 : "");
    const [isFusionLoaded, setIsFusionLoaded] = (0,react.useState)(false);
    const prevRows = (0,usePrevious/* default */.Z)(curRows);
    const [isLoadMore, setIsLoadMore] = (0,react.useState)(false);
    const { searchDetails ={} , searchResponse: { data: { fusion: searchFusion = {}  } = {}  } = {}  } = (0,es/* useSelector */.v9)(searchSlice/* searchState */.uv);
    const { data =[] , total , facets ={} , facetLabels , colors  } = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
    const { access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const retainedFilters = searchDetails.keyword === searchKeyword && ((ref = searchDetails[type]) === null || ref === void 0 ? void 0 : ref.filters) ? searchDetails[type].filters : [];
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(async (config)=>{
            const brandName = get_default()(config, "general.siteName");
            setSiteName(brandName);
        });
        const selectedSortItem = (0,helper/* getSortItemBasedOnURL */.KE)(staticTexts, {
            name: "Featured"
        });
        setSelectedSort(selectedSortItem);
    }, []);
    const filterClass = classnames_default()({
        "product-listing__filter": true,
        "product-listing__filter--hide": !lib/* isTablet */.Em && !lib/* isMobile */.tq || width > 992 ? !showFilter : false,
        "product-listing__filter--modal": lib/* isTablet */.Em || lib/* isMobile */.tq || width < 992 ? showFilter : false
    });
    const tileClass = classnames_default()({
        "product-listing__tile-col": true,
        "product-listing__tile-col--full-width": !lib/* isTablet */.Em && !lib/* isMobile */.tq || width > 992 ? !showFilter : true
    });
    const sorts = [
        {
            name: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.featured
        },
        {
            name: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.atoz,
            query: "productName_s+asc"
        },
        {
            name: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.ztoa,
            query: "productName_s+desc"
        }
    ];
    const executeScroll = ()=>{
        modules/* scroller.scrollTo */.OK.scrollTo("products-tab", {
            duration: 1500,
            delay: 0,
            smooth: "easeInOutQuart"
        });
    };
    (0,react.useEffect)(()=>{
        lib/* isTablet */.Em ? window.outerWidth >= 1024 ? setRowCols(3) : setRowCols(2) : lib/* isMobile */.tq ? isLandscape ? setRowCols(2) : setRowCols(2) : setRowCols(3);
    }, [
        isLandscape,
        width
    ]);
    (0,react.useEffect)(()=>{
        if (accessToken && filterQueries != null) {
            // will trigger from onLoadMore
            if (start) {
                generateListingUrl(isLoadMore, false);
            // Will trigger when user coming back from PDP page
            } else if (start == 0 && scrollToSku) {
                setScrollToSku("");
                generateListingUrl(false, true);
            } else if (start == 0 && curRows && !!prevRows && prevRows > curRows) {
                generateListingUrl(false, true);
            } else if (start == 0 && curRows) {
                generateListingUrl(false, false);
            }
        }
    }, [
        accessToken,
        start,
        curRows,
        selectedSort,
        filterQueries
    ]);
    (0,react.useEffect)(()=>{
        switch(true){
            case width > 1024:
                setRowCols(1);
                break;
            case width < 668:
                setRowCols(1);
                break;
            default:
                setRowCols(1);
        }
    }, [
        isLandscape,
        width
    ]);
    (0,react.useEffect)(()=>{
        // To scrollup the product list on back
        if (dataPopulated) (0,ProductsTab_helper/* scrollToProduct */.C1)();
    }, [
        dataPopulated
    ]);
    (0,react.useEffect)(()=>{
        if (showFilter && (width < 992 || lib/* isMobile */.tq || lib/* isTablet */.Em)) {
            var ref;
            filterModalWindow === null || filterModalWindow === void 0 ? void 0 : (ref = filterModalWindow.current) === null || ref === void 0 ? void 0 : ref.focus();
        } else if (!showFilter && (width < 992 || lib/* isMobile */.tq || lib/* isTablet */.Em)) {
            var ref1;
            (ref1 = document.getElementById("showFilter")) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    }, [
        showFilter
    ]);
    (0,react.useEffect)(()=>{
        if (!isEmpty_default()(searchFusion) && accessToken && !isFusionLoaded) {
            setIsFusionLoaded(true);
            if (retainedFilters.length > 0) {
                setFilterQueries(retainedFilters);
            } else {
                const filterQuery = (0,helper/* getAllFilterQueries */.ud4)({
                    attributeName: ""
                }, searchFusion, marketParamValues);
                setFilterQueries(filterQuery);
                dispatch((0,searchSlice/* setSearchKeyword */.Ec)(searchKeyword));
                dispatch((0,searchSlice/* setSearchFilter */.Qf)({
                    queries: filterQuery,
                    key: type
                }));
                (0,helper/* retainSearchQueryParams */.mSA)(type);
            }
        }
    }, [
        searchFusion,
        accessToken
    ]);
    const onRows = (rows)=>{
        setStart(0);
        setCurRows(rows);
    };
    const onLoadMore = ()=>{
        setIsLoadMore(true);
        setStart(start + curRows);
    };
    const onSort = (query)=>{
        setStart(0);
        (0,helper/* replaceSearchUrl */.CjH)("sort", query === null || query === void 0 ? void 0 : query.query);
        (0,helper/* replaceSearchUrl */.CjH)("tab", type);
        (0,helper/* retainSearchQueryParams */.mSA)(type);
        setSelectedSort(query);
    };
    const generateListingUrl = function(update) {
        let enableScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, queries = arguments.length > 2 ? arguments[2] : void 0;
        let callStart = 0;
        const persona = (0,helper/* getUserPersona */.shu)();
        if (!queries && retainedFilters.length > 0) {
            setFilterQueries(retainedFilters);
            queries = retainedFilters;
        } else {
            queries = filterQueries;
            callStart = start;
            dispatch((0,searchSlice/* setSearchKeyword */.Ec)(searchKeyword));
            dispatch((0,searchSlice/* setSearchFilter */.Qf)({
                queries: filterQueries,
                key: type
            }));
        }
        const fq = [
            'Technical:("Yes")'
        ];
        queries === null || queries === void 0 ? void 0 : queries.forEach((q)=>fq.push("".concat(q.facet, ':("').concat(encodeURIComponent(q.value.join('","')), '")')));
        const query = {
            fq,
            rows: curRows,
            start: callStart
        };
        if (selectedSort.name !== staticTexts.featured) {
            if (selectedSort.name) {
                query.sort = selectedSort.query;
            }
        }
        const fl = [
            "id",
            "slug_s",
            "masterSKU_s",
            "productName_s",
            "Product_Category",
            "productImages.url_ss",
            "ProductSustainability_s",
            "ProductBrandName_s",
            "ProductADACompliant_s",
            "ProductBrandNameDisplay_s",
            "ProductDescriptionProductShort_s",
            "ProductResource.DXFPlanView.resourceFullWebURL_ss",
            "ProductResource.DWGPlanView.resourceFullWebURL_ss",
            "ProductResource.DXFFrontView.resourceFullWebURL_ss",
            "ProductResource.DWGFrontView.resourceFullWebURL_ss",
            "ProductResource.DXFSideView.resourceFullWebURL_ss",
            "ProductResource.DWGSideView.resourceFullWebURL_ss",
            "ProductResource.3DDXFSymbol.resourceFullWebURL_ss",
            "ProductResource.3DDWGSymbol.resourceFullWebURL_ss",
            "ProductResource.3DRevit.resourceFullWebURL_ss",
            "ProductResource.3D3DS.resourceFullWebURL_ss",
            "ProductResource.3DSketchup.resourceFullWebURL_ss",
            "ProductResource.CutOutDXF.resourceFullWebURL_ss",
            "ProductResource.3DOBJ.resourceFullWebURL_ss",
            "ProductResource.SpecPDFFileName.resourceFullWebURL_ss",
            "ProductResource.SpecPDFFileName.resourceTitle_ss",
            "ProductResource.EnvironProdDecl.resourceFullWebURL_ss",
            "ProductResource.EnvironProdDecl.resourceTitle_ss",
            "ProductResource.HomeownersGuide.resourceFullWebURL_ss",
            "ProductResource.HomeownersGuide.resourceTitle_ss",
            "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
            "ProductResource.InstallationWithoutSPPDF.resourceTitle_ss",
            "ProductIsRetail",
            "comboSKUAvailable_b",
            "ProductProductNo_s",
            "category1_s",
            "priceList.".concat(persona, ".finalPrice_d"),
            "priceList.".concat(persona, ".discountedPrice_d"),
            "priceList.".concat(persona, ".saleOffer_s"),
            "priceStartingAt.".concat(persona, "_d"),
            "discountedPriceStartingAt.".concat(persona, "_d"),
            "Tile_Title"
        ];
        const queryParams = {
            q: searchKeyword,
            fl: fl.join(","),
            ...query,
            displaytype: "search",
            update
        };
        if (enableScroll) setDataPopulated(false);
        dispatch((0,productListSlice/* getProducts */.Xp)({
            ...queryParams
        })).then(()=>{
            if (enableScroll) setDataPopulated(true);
        }).catch(()=>{
            if (enableScroll) setDataPopulated(false);
        });
    };
    const handleKeyPress = (e)=>{
        if (width < 992) {
            var ref;
            const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]) [role="button]:not([hidden=true])';
            const focusContent = filterModalWindow === null || filterModalWindow === void 0 ? void 0 : (ref = filterModalWindow.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll(focusElements);
            const firstElem = focusContent[0];
            const lastElem = focusContent[focusContent.length - 1].disabled ? focusContent[focusContent.length - 2] : focusContent[focusContent.length - 1];
            if (e.key === "Escape") {
                setShowFilter(false);
            }
            if (e.key === "Tab") {
                if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === filterModalWindow.current)) {
                    e.preventDefault();
                    lastElem.focus();
                }
                if (!e.shiftKey && document.activeElement === lastElem) {
                    e.preventDefault();
                    firstElem.focus();
                }
            }
        }
    };
    const handleBackToTop = ()=>{
        var ref;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        (ref = document.getElementById("kf-product-list-tile-details-0")) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const handleFilter = (queries)=>{
        setIsLoadMore(false);
        dispatch((0,searchSlice/* setSearchKeyword */.Ec)(searchKeyword));
        dispatch((0,searchSlice/* setSearchFilter */.Qf)({
            queries,
            key: type
        }));
        setFilterQueries(queries);
        (0,ProductsTab_helper/* scrollToFirstProduct */.nj)();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((Sort_index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "product-listing productListing_technical",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stickyNavHeader["default"], {
                    showFilter: showFilter,
                    rowCols: rowCols,
                    setShowFilter: setShowFilter,
                    setRowCols: setRowCols,
                    staticTexts: staticTexts,
                    sorts: sorts,
                    selectedSort: selectedSort,
                    handleSort: onSort,
                    totalResults: totalResults,
                    isSearchTab: true,
                    searchKeyword: searchKeyword,
                    onSearch: onSearch,
                    page: page,
                    type: type
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container kf-react-plp-container product-listing__tiles",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-listing__row d-block",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "filter-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: filterClass,
                                    "aria-modal": true,
                                    ref: filterModalWindow,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-listing__filter--sticky",
                                        "aria-hidden": !showFilter,
                                        onKeyDown: handleKeyPress,
                                        children: facets && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter["default"], {
                                            rowCols: rowCols,
                                            texts: staticTexts,
                                            sort: sorts,
                                            selectedSort: selectedSort,
                                            onSortChange: onSort,
                                            currFilters: filterQueries,
                                            selectedFilterCount: filterQueries && filterQueries.reduce((acc, item)=>{
                                                return acc + item.value.length;
                                            }, 0),
                                            onFilter: handleFilter,
                                            close: setShowFilter,
                                            colors: colors,
                                            discontinuedCheck: false,
                                            displayShare: true,
                                            displayPrint: true,
                                            showFilter: showFilter,
                                            handleScroll: executeScroll,
                                            totalResults: total,
                                            showSort: width <= 991,
                                            type: type,
                                            tabIndex: "0",
                                            hidePriceRange: true,
                                            page: page || "",
                                            facetData: facets,
                                            facetLabels: facetLabels,
                                            addToUrl: siteName !== null && siteName !== void 0 ? siteName : false,
                                            isLandscape: isLandscape
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: tileClass,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-listing__row row-cols-1",
                                            role: "list",
                                            children: data.map((element, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "product-listing__tile",
                                                        role: "listitem",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                            className: "lazyload-wrapper kf-lazyload-wrapper",
                                                            height: "300",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalTile/* default */.Z, {
                                                                page: page,
                                                                data: element,
                                                                fullWidth: !showFilter,
                                                                staticTexts: staticTexts,
                                                                highlightText: searchKeyword
                                                            })
                                                        })
                                                    })
                                                }, i))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                            isSearchTab: true,
                                            staticTexts: staticTexts,
                                            displayShare: displayShare,
                                            displayPrint: displayPrint,
                                            curRows: curRows,
                                            productsPerPage: productsPerPage,
                                            totalResults: total,
                                            onRows: onRows,
                                            handleBackToTop: handleBackToTop,
                                            width: width,
                                            page: page,
                                            type: type,
                                            data: data,
                                            onLoadMore: onLoadMore
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var v1_TechnicalTab = (TechnicalTab);

// EXTERNAL MODULE: ./components/ProductList/v2/ProductTile/index.jsx + 1 modules
var ProductTile = __webpack_require__(1866);
// EXTERNAL MODULE: ./utils/product.js
var utils_product = __webpack_require__(29843);
// EXTERNAL MODULE: ./src/components/PromoBanner/v2/PromoBanner.jsx
var PromoBanner = __webpack_require__(67098);
// EXTERNAL MODULE: ./src/components/PartsViewer/v1/PartsViewer.jsx
var PartsViewer = __webpack_require__(96005);
// EXTERNAL MODULE: ./src/hooks/useSmartCrop.js
var useSmartCrop = __webpack_require__(83839);
// EXTERNAL MODULE: ./store/features/compareSlice.js
var compareSlice = __webpack_require__(39915);
// EXTERNAL MODULE: ./src/components/ProductList/v2/ProductTile/index.module.scss
var ProductTile_index_module = __webpack_require__(20711);
var ProductTile_index_module_default = /*#__PURE__*/__webpack_require__.n(ProductTile_index_module);
// EXTERNAL MODULE: ./src/components/ProductList/v2/PLPLoader/index.jsx
var PLPLoader = __webpack_require__(26655);
;// CONCATENATED MODULE: ./components/Search/v1/ProductsTab/index.jsx











//import ProductTile from "@/components/ProductTile/v2"






















const ProductsTab = (param)=>{
    let { staticTexts ={} , totalSearchResults =0 , count =0 , searchKeyword ="" , onSearch =()=>{} , type ="" , page ="" , currencySign ="" , lwAppName ="" , query: queryProp = "" , isLandscape =false , promoJson ={} , presetConfigs ="" , componentProps: { disableBestSellers =false , isAnnsacksPlp =""  } = {} , marketParamValues =[] , isSterling =false , sterlingData =[] , showSterlingButton =false , plpBadge ={}  } = param;
    var ref;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { searchDetails ={} , searchResponse: { data: { fusion: searchFusion = {}  } = {}  } = {}  } = (0,es/* useSelector */.v9)(searchSlice/* searchState */.uv);
    const { data =[] , total , facets =[] , facetLabels , status , colors , fusion ={}  } = (0,es/* useSelector */.v9)(productListSlice/* selectProductListState */.rv).plp;
    const retainedFilters = searchDetails.keyword === searchKeyword && ((ref = searchDetails[type]) === null || ref === void 0 ? void 0 : ref.filters) ? searchDetails[type].filters : [];
    const compareData = (0,es/* useSelector */.v9)(compareSlice/* compareState */.NP);
    const { access_token: accessToken  } = (0,es/* useSelector */.v9)(authSlice/* selectAuthState */._9);
    const productsPerPage = constants.PRODUCTS_PER_PAGE;
    const [width] = (0,useWindowResize/* default */.Z)();
    const initialPartData = {
        productId: "",
        partId: "",
        isShowModal: false
    };
    const [showFilter, setShowFilter] = (0,react.useState)(width >= 1024 ? true : false);
    const [rowCols, setRowCols] = (0,react.useState)(width < 1024 ? 1 : 3);
    const [sessionId, setSessionId] = (0,react.useState)("");
    const [paginationState, setPaginationState] = (0,react.useState)({
        curRows: 30,
        start: 0
    });
    const { curRows , start  } = paginationState;
    const prevRows = (0,usePrevious/* default */.Z)(curRows);
    var ref1;
    const [scrollToSku, setScrollToSku] = (0,react.useState)((ref1 = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.plpScrollSku) !== null && ref1 !== void 0 ? ref1 : "");
    const filterModalWindow = (0,react.useRef)(null);
    const [selectedSort, setSelectedSort] = (0,react.useState)({});
    const [filterQueries, setFilterQueries] = (0,react.useState)(null);
    const [swatchCount, setSwatchCount] = (0,react.useState)(5);
    const [xfLink, setXfLink] = (0,react.useState)("");
    const [promoLayout, setPromoLayout] = (0,react.useState)("one-column");
    const [desktopPromo, setDesktopPromo] = (0,react.useState)(3);
    const [mobilePromo, setMobilePromo] = (0,react.useState)(4);
    const [partData, setPartsData] = (0,react.useState)(initialPartData);
    const smartCrop = (0,useSmartCrop/* default */.Z)();
    const [fusionQueryId, setFusionQueryId] = (0,react.useState)("");
    const [dataPopulated, setDataPopulated] = (0,react.useState)(false);
    const [dataInitPopulated, setDataInitPopulated] = (0,react.useState)(false);
    const [isFusionLoaded, setIsFusionLoaded] = (0,react.useState)(false);
    const [isRendering, setIsRendering] = (0,react.useState)(true);
    const [zeroResults, setZeroResults] = (0,react.useState)(false);
    const [localData, setLocalData] = (0,react.useState)(data);
    const [isLoadMore, setIsLoadMore] = (0,react.useState)(false);
    const persona = (0,helper/* getUserPersona */.shu)();
    // const [shownoResultText, setShownoResultText ] = useState(false)
    (0,react.useEffect)(()=>{
        const selectedSortItem = (0,helper/* getSortItemBasedOnURL */.KE)(staticTexts, {
            name: "Featured"
        });
        setSelectedSort(selectedSortItem);
    }, []);
    (0,react.useEffect)(()=>{
        setIsRendering(false);
        const handleResize = ()=>setSwatchCount((0,helper/* getSwatchCount */.m3S)(false));
        window.addEventListener("resize", handleResize);
        const cookie = document === null || document === void 0 ? void 0 : document.cookie;
        const cookieArray = cookie === null || cookie === void 0 ? void 0 : cookie.split(";");
        const sessionCookie = cookieArray.filter((item)=>{
            return item === null || item === void 0 ? void 0 : item.includes("session#");
        })[0];
        const sessionIdString = sessionCookie === null || sessionCookie === void 0 ? void 0 : sessionCookie.split("|")[1];
        setSessionId(sessionIdString === null || sessionIdString === void 0 ? void 0 : sessionIdString.split("#")[1]);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    (0,react.useEffect)(()=>{
        if (isSterling && sterlingData.length > 0) {
            setLocalData(sterlingData);
        } else {
            setLocalData(data);
        }
    }, [
        isSterling,
        data
    ]);
    (0,react.useEffect)(()=>{
        if (dataInitPopulated && typeof total !== "undefined" && total === 0) {
            setZeroResults(true);
        } else {
            setZeroResults(false);
        }
    }, [
        dataInitPopulated,
        total
    ]);
    (0,react.useEffect)(()=>{
        const search = window.location.search;
        if (!isEmpty_default()(searchFusion) && accessToken && !isFusionLoaded) {
            setIsFusionLoaded(true);
            if (retainedFilters.length > 0) {
                setFilterQueries(retainedFilters);
            } else {
                const filterQuery = (0,helper/* getAllFilterQueries */.ud4)({
                    attributeName: ""
                }, searchFusion, marketParamValues);
                dispatch((0,searchSlice/* setSearchKeyword */.Ec)(searchKeyword));
                if (!search.includes("tab=")) {
                    setFilterQueries(filterQuery);
                    dispatch((0,searchSlice/* setSearchFilter */.Qf)({
                        queries: filterQuery,
                        key: type
                    }));
                } else {
                    if (search.includes("tab=".concat(type))) {
                        setFilterQueries(filterQuery);
                        dispatch((0,searchSlice/* setSearchFilter */.Qf)({
                            queries: filterQuery,
                            key: type
                        }));
                    }
                }
                (0,helper/* retainSearchQueryParams */.mSA)(type);
            }
        }
    }, [
        searchFusion,
        accessToken
    ]);
    (0,react.useEffect)(()=>{
        if (accessToken && filterQueries != null) {
            // will trigger from onLoadMore
            if (start) {
                generateListingUrl(isLoadMore, false);
            // Will trigger when user coming back from PDP page
            } else if (start == 0 && scrollToSku) {
                setScrollToSku("");
                generateListingUrl(false, true);
            } else if (start == 0 && curRows && !!prevRows && prevRows > curRows) {
                generateListingUrl(false, true);
            } else if (start == 0 && curRows) {
                generateListingUrl(false, false);
            }
        }
    }, [
        accessToken,
        start,
        curRows,
        selectedSort,
        filterQueries,
        isLoadMore
    ]);
    (0,react.useEffect)(()=>{
        if ((fusion === null || fusion === void 0 ? void 0 : fusion.fusionQueryId) !== undefined) {
            setFusionQueryId(fusion.fusionQueryId);
        }
        if (fusion && (fusion === null || fusion === void 0 ? void 0 : fusion.experiment_fragments) && (fusion === null || fusion === void 0 ? void 0 : fusion.experiment_fragments) !== undefined) {
            var ref, ref1, ref2, ref3;
            var ref4;
            setXfLink((ref4 = (ref = fusion === null || fusion === void 0 ? void 0 : fusion.experiment_fragments[0]) === null || ref === void 0 ? void 0 : ref.url_s) !== null && ref4 !== void 0 ? ref4 : "");
            var ref5;
            setPromoLayout((ref5 = (ref1 = fusion === null || fusion === void 0 ? void 0 : fusion.experiment_fragments[0]) === null || ref1 === void 0 ? void 0 : ref1.promoLayout_s) !== null && ref5 !== void 0 ? ref5 : "one-column");
            var ref6;
            setDesktopPromo((ref6 = (ref2 = fusion === null || fusion === void 0 ? void 0 : fusion.experiment_fragments[0]) === null || ref2 === void 0 ? void 0 : ref2.promoPlacementDesktop_s) !== null && ref6 !== void 0 ? ref6 : 3);
            var ref7;
            setMobilePromo((ref7 = (ref3 = fusion === null || fusion === void 0 ? void 0 : fusion.experiment_fragments[0]) === null || ref3 === void 0 ? void 0 : ref3.promoPlacementMobile_s) !== null && ref7 !== void 0 ? ref7 : 4);
        }
    }, [
        fusion
    ]);
    (0,react.useEffect)(()=>{
        // To scrollup the product list on back
        if (dataPopulated) (0,ProductsTab_helper/* scrollToProduct */.C1)();
    }, [
        dataPopulated
    ]);
    (0,react.useEffect)(()=>{
        switch(true){
            case width === 1024:
                setRowCols(2);
                break;
            case width > 1024:
                setRowCols(3);
                break;
            case width < 813:
                setRowCols(2);
                break;
            default:
                setRowCols(3);
        }
    }, [
        isLandscape,
        width
    ]);
    const tileClass = classnames_default()({
        "product-listing__tile-col": true,
        "product-listing__tile-col--full-width": !showFilter
    });
    const filterClass = classnames_default()({
        "product-listing__filter": true,
        "product-listing__filter--hide": !showFilter,
        "product-listing__filter--modal": showFilter
    });
    const sortList = (0,ProductsTab_helper/* getSortList */.ur)(staticTexts);
    const sortsCopy = [
        ...sortList
    ];
    sortsCopy.splice(sortsCopy.findIndex((a)=>a.query === "bestSeller_l+asc"), 1);
    const customizedSort = disableBestSellers ? sortsCopy : sortList;
    // calculate promo position
    const col = width < 768 ? {
        "one-column": "promo-col-3",
        "two-column": "promo-col-3",
        "three-column": "promo-col-3"
    } : width > 768 && width < 1280 ? {
        "one-column": "promo-col-1",
        "two-column": "promo-col-3",
        "three-column": "promo-col-3"
    } : {
        "one-column": "promo-col-1",
        "two-column": "promo-col-2",
        "three-column": "promo-col-3"
    };
    const colVal = {
        "one-column": 1,
        "two-column": 2,
        "three-column": 3
    };
    const row = lib/* isMobile */.tq ? mobilePromo : desktopPromo;
    const position = lib/* isMobile */.tq && window.outerWidth < 1024 ? rowCols === 1 ? row - 1 : row * rowCols - 2 : row * rowCols - colVal[promoLayout];
    const handleSort = (item)=>{
        setPaginationState((state)=>({
                ...state,
                start: 0
            }));
        setSelectedSort(item);
        (0,helper/* replaceSearchUrl */.CjH)("sort", item === null || item === void 0 ? void 0 : item.query);
        (0,helper/* replaceSearchUrl */.CjH)("tab", type);
        (0,helper/* retainSearchQueryParams */.mSA)(type);
        (0,ProductsTab_helper/* scrollToFirstProduct */.nj)();
    };
    const handleFilter = (queries)=>{
        setIsLoadMore(false);
        dispatch((0,searchSlice/* setSearchKeyword */.Ec)(searchKeyword));
        dispatch((0,searchSlice/* setSearchFilter */.Qf)({
            queries,
            key: type
        }));
        setFilterQueries(queries);
        (0,ProductsTab_helper/* scrollToFirstProduct */.nj)();
    };
    const generateListingUrl = function(update) {
        let enableScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, queries = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : filterQueries !== null && filterQueries !== void 0 ? filterQueries : [];
        const personaTemp = (0,helper/* getUserPersona */.shu)();
        // check this
        const callStart = start;
        const fq = (0,ProductsTab_helper/* getFilterQuery */.sR)(type, queryProp, queries, personaTemp);
        const fl = (0,ProductsTab_helper/* getFlData */.c9)(personaTemp);
        const query = {
            fq,
            rows: curRows,
            start: isLoadMore ? callStart : 0
        };
        if (selectedSort.name !== staticTexts.Featured) {
            if (selectedSort.query === "price+asc") {
                query.sort = "".concat((0,helper/* getPriceSortQuery */.YHw)(), "+asc");
            } else if (selectedSort.query === "price+desc") {
                query.sort = "".concat((0,helper/* getPriceSortQuery */.YHw)(), "+desc");
            } else {
                query.sort = selectedSort.query;
            }
        }
        const arg = {
            q: searchKeyword,
            fl: fl.join(","),
            ...query,
            profileName: type === "Parts" ? "profile_service_parts_Search" : "profile_".concat(lwAppName.toLowerCase(), "_Search"),
            collections: type === "Parts" ? "service_parts" : lwAppName.toLowerCase(),
            displaytype: "search",
            update
        };
        if (enableScroll) setDataPopulated(false);
        setDataInitPopulated(false);
        dispatch((0,productListSlice/* getProducts */.Xp)({
            ...arg
        })).unwrap().then((obj)=>{
            setDataInitPopulated(true);
            if (enableScroll) setDataPopulated(true);
        }).catch(()=>{
            setDataInitPopulated(false);
            if (enableScroll) setDataPopulated(false);
        });
    };
    const handleOnClickPartsDiagramLink = (data)=>{
        const getPartId = "";
        const partId = Array.isArray(getPartId) ? getPartId[0] : getPartId;
        setPartsData({
            partId,
            productId: data.ProductProductNo_s,
            isShowModal: true
        });
    };
    const executeScroll = ()=>{
        modules/* scroller.scrollTo */.OK.scrollTo("products-tab", {
            duration: 1500,
            delay: 0,
            smooth: "easeInOutQuart"
        });
    };
    // Will trigger when pagination changes
    const onRows = (rows)=>{
        setPaginationState({
            start: 0,
            curRows: rows
        });
    };
    // Will trigger on load more clicks
    const onLoadMore = ()=>{
        setIsLoadMore(true);
        setPaginationState((state)=>({
                ...state,
                start: start + curRows
            }));
    };
    const handleBackToTop = ()=>{
        var ref;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        (ref = document.getElementById("kf-product-list-tile-details-0")) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const onCloseModal = ()=>{
        setPartsData({
            ...initialPartData,
            isShowModal: false
        });
    };
    const { productId ="" , partId ="" , isShowModal =false  } = partData;
    let promoIndex = 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper, " ").concat((Sort_index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-listing",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stickyNavHeader["default"], {
                        showFilter: showFilter,
                        rowCols: rowCols,
                        setShowFilter: setShowFilter,
                        setRowCols: setRowCols,
                        staticTexts: staticTexts,
                        sorts: customizedSort,
                        selectedSort: selectedSort,
                        handleSort: handleSort,
                        totalResults: totalSearchResults,
                        searchKeyword: searchKeyword,
                        onSearch: onSearch,
                        type: type,
                        page: page,
                        isSearchTab: true
                    }),
                    !isRendering ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container kf-react-plp-container product-listing__tiles",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "product-listing__row d-block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "filter-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: filterClass,
                                        "aria-modal": true,
                                        ref: filterModalWindow,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-listing__filter--sticky",
                                            "aria-hidden": !showFilter,
                                            onKeyDown: (e)=>(0,ProductsTab_helper/* handleKeyPress */.n4)(e, width, filterModalWindow, setShowFilter),
                                            children: facets && /*#__PURE__*/ (0,jsx_runtime.jsx)(Filter["default"], {
                                                tabIndex: "0",
                                                page: page,
                                                texts: staticTexts,
                                                currencySign: currencySign,
                                                facetData: facets,
                                                facetLabels: facetLabels,
                                                currFilters: filterQueries,
                                                sort: customizedSort,
                                                selectedSort: selectedSort,
                                                onSortChange: handleSort,
                                                selectedFilterCount: filterQueries && filterQueries.reduce((acc, item)=>{
                                                    return acc + item.value.length;
                                                }, 0),
                                                onFilter: handleFilter,
                                                close: setShowFilter,
                                                colors: colors,
                                                displayShare: true,
                                                displayPrint: true,
                                                handleScroll: executeScroll,
                                                showFilter: showFilter,
                                                totalResults: total,
                                                showSort: width <= 991,
                                                type: type || "products",
                                                isAnnsacksPlp: isAnnsacksPlp,
                                                addToUrl: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: tileClass,
                                        children: localData.length === 0 ? count === 0 || zeroResults ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "product-list__no-results",
                                            dangerouslySetInnerHTML: {
                                                __html: staticTexts.searchNoResultErrorMessage
                                            }
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((ProductListView_index_module_default()).productListWrapper, " ").concat((ProductTile_index_module_default()).productTileWrapper, " ").concat((Sort_index_module_default()).productListingSearchWrapper, " ").concat((Filter_index_module_default()).productListingFilterWrapper),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PLPLoader/* default */.Z, {})
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "product-listing__row row-cols-".concat(rowCols),
                                                    children: localData.map((product, i)=>{
                                                        var ref, ref1;
                                                        const positionRemainder = (i + 1) % position;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "product-listing__tile",
                                                                    id: product["masterSKU_s"],
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyLoad/* default */.Z, {
                                                                        className: "kf-lazyload-wrapper",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTile/* default */.Z, {
                                                                            loading: status !== "succeeded",
                                                                            data: product,
                                                                            texts: staticTexts,
                                                                            category: (ref = product["Product_Category"]) === null || ref === void 0 ? void 0 : ref.replace(/\s/g, "-").toLowerCase(),
                                                                            lite: !isLandscape ? rowCols === 2 : false,
                                                                            addToCompare: utils_product/* addToCompareProduct */.dX,
                                                                            removeFromCompare: utils_product/* removeFromCompareProduct */.Zj,
                                                                            compareData: compareData,
                                                                            highlightText: searchKeyword,
                                                                            currencySign: currencySign,
                                                                            mapImageToColor: true,
                                                                            currFilters: filterQueries,
                                                                            index: i,
                                                                            swatchCount: swatchCount,
                                                                            favorites: (ref1 = (0,helper/* getFavouraties */.MqV)()) === null || ref1 === void 0 ? void 0 : ref1.lineItems,
                                                                            type: type,
                                                                            rowCols: rowCols,
                                                                            presetConfigs: presetConfigs,
                                                                            isPartsDiagramLinkVisible: false,
                                                                            handleOnClickPartsDiagramLink: handleOnClickPartsDiagramLink,
                                                                            fusionQueryId: fusionQueryId,
                                                                            parent: "search",
                                                                            onRows: onRows,
                                                                            sessionId: sessionId,
                                                                            isSterling: isSterling,
                                                                            sterlingData: sterlingData,
                                                                            showSterlingButton: showSterlingButton,
                                                                            plpBadge: plpBadge,
                                                                            saleInfo: product["Sale.".concat(persona, ".Details_ss")]
                                                                        })
                                                                    })
                                                                }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s)),
                                                                xfLink && positionRemainder === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat(col[promoLayout], " product-listing__tile"),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoBanner/* default */.Z, {
                                                                        promoJson: promoJson,
                                                                        xfLink: xfLink,
                                                                        col: colVal[promoLayout],
                                                                        position: 0,
                                                                        promoIndex: ++promoIndex,
                                                                        smartCrop: smartCrop,
                                                                        width: width
                                                                    })
                                                                })
                                                            ]
                                                        }, "".concat(i, "-").concat(product.Product_Category, "-").concat(product.ctId_s));
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                    displayShare: true,
                                                    displayPrint: true,
                                                    totalResults: isSterling ? 1 : total,
                                                    isSearchTab: true,
                                                    staticTexts,
                                                    onLoadMore,
                                                    curRows,
                                                    data,
                                                    productsPerPage,
                                                    onRows,
                                                    handleBackToTop,
                                                    width,
                                                    page,
                                                    type
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OuterSearchProgressive, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsViewer/* default */.Z, {
                productId: productId,
                partId: partId,
                showModal: isShowModal,
                page: page + " results",
                onClose: onCloseModal
            })
        ]
    });
};
/* harmony default export */ var v1_ProductsTab = (ProductsTab);

;// CONCATENATED MODULE: ./components/Search/v1/Search.jsx
















const SearchComponent = (props)=>{
    var ref, ref1;
    const dispatch = (0,es/* useDispatch */.I0)();
    const newState = (0,es/* useSelector */.v9)(searchSlice/* searchState */.uv);
    const { searchResponse  } = newState;
    const productsPerPage = constants.PRODUCTS_PER_PAGE;
    const { data: componentProp , header: headerProps  } = props;
    const [total, setTotal] = (0,react.useState)(0);
    const [selected, setSelected] = (0,react.useState)({});
    const [partsData, setPartsData] = (0,react.useState)({});
    const [searchKeyword, setSearchKeyword] = (0,react.useState)("");
    const [searchMainKeyword, setSearchMainKeyword] = (0,react.useState)("");
    const [loading, setLoading] = (0,react.useState)(true);
    const [exactMatch, setExactMatch] = (0,react.useState)(false);
    const [tagDebug, setTagDebug] = (0,react.useState)(true);
    const [searchClickEvent, setSearchClickEvent] = (0,react.useState)(false);
    const [debounceInProgress, setDebounceInProgress] = (0,react.useState)(false);
    const [isFromServicePart, setIsFromServicePart] = (0,react.useState)(false);
    const [general, setGeneral] = (0,react.useState)();
    const [isInitialLoad, setIsInitialLoad] = (0,react.useState)(true);
    // eslint-disable-next-line no-unused-vars
    const [info, setInfo] = (0,react.useState)({});
    const [loadPopularSearch, setLoadPopularSearch] = (0,react.useState)(false);
    const [isSterling, setIsSterling] = (0,react.useState)(false);
    const [plpBadge, setPlpBadge] = (0,react.useState)({});
    const [leadTimeData, setLeadTimeData] = (0,react.useState)(null);
    const pageLoadedRef = (0,react.useRef)(false);
    const staticTexts = (0,useSearchi18n/* default */.Z)({
        componentProp
    });
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(async (config)=>{
            var ref;
            const { plpConfigurations: { myArrayList: plpBadgeList = []  } = {}  } = config;
            var ref1;
            const brandName = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName) !== null && ref1 !== void 0 ? ref1 : "";
            const locale = get_default()(config, "internationalization.locale", "");
            const currencySign = get_default()(config, "internationalization.currencySign", "");
            const currencyCode = get_default()(config, "internationalization.currencyCode", "");
            const knowledgeArticleUrl = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.knowledgeArticlePath", ""));
            const marketParamValues = get_default()(config, "marketParamValues");
            const { general: { lwAppName =""  } = {}  } = config !== null && config !== void 0 ? config : {};
            const info = {
                locale: locale,
                currencySign: currencySign,
                currencyCode: currencyCode,
                knowledgeArticleUrl: knowledgeArticleUrl,
                lwAppName
            };
            var ref2;
            const displayOrderBadges = (ref2 = plpBadgeList.find((item)=>item.map.Key === "displayOrderBadges")) !== null && ref2 !== void 0 ? ref2 : {};
            const { map: { Values: { myArrayList: displayOrderBadgeList = []  } = {}  } = {}  } = displayOrderBadges;
            const plpBadges = {};
            displayOrderBadgeList.forEach((item)=>{
                plpBadges[item] = (0,helper/* getBadgeValue */.FcF)(item, plpBadgeList);
            });
            const general = {
                brandName: brandName,
                marketParamValues: marketParamValues,
                lwAppName: lwAppName
            };
            setInfo(info);
            setGeneral(general);
            setPlpBadge({
                plpBadges,
                displayOrderBadgeList
            });
            setTimeout(function() {
                setIsInitialLoad(false);
            }, 2000);
        });
        try {
            var ref, ref1;
            const urlParams = new URL(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
            if (urlParams === null || urlParams === void 0 ? void 0 : (ref1 = urlParams.searchParams) === null || ref1 === void 0 ? void 0 : ref1.get("keyword")) {
                var ref2;
                const keyword = decodeURIComponent(urlParams === null || urlParams === void 0 ? void 0 : (ref2 = urlParams.searchParams) === null || ref2 === void 0 ? void 0 : ref2.get("keyword"));
                const isFromServicePart = decodeURIComponent(urlParams === null || urlParams === void 0 ? void 0 : urlParams.searchParams.get("service"));
                if ((keyword === null || keyword === void 0 ? void 0 : keyword.length) < 3) {
                    setSearchKeyword(keyword);
                    setLoadPopularSearch(true);
                    setLoading(false);
                } else {
                    setSearchKeyword(keyword);
                    setIsFromServicePart(isFromServicePart === "true");
                    setLoading(true);
                }
            } else {
                setLoadPopularSearch(true);
                setLoading(false);
            }
        } catch (error) {
            setLoadPopularSearch(true);
            setLoading(false);
            console.error("URIError: malformed URI sequence");
        }
        (0,api/* aemAxiosInstance */.Gb)({
            url: constants.LEAD_TIME_DOCUMENT_ENDPOINT,
            params: {
                path: "/content/annsacks/us/en/lead-time",
                contextPath: "/content/annsacks"
            }
        }).then((res)=>{
            if (res === null || res === void 0 ? void 0 : res.data) {
                var ref, ref1, ref2, ref3, ref4;
                let leadTimeData = {
                    contentSource_s: "asset",
                    eyeBrowText_s: (ref = res === null || res === void 0 ? void 0 : res.data[0]) === null || ref === void 0 ? void 0 : ref.pageTitle,
                    externalRedirectUrl_s: (ref1 = res.data[0]) === null || ref1 === void 0 ? void 0 : ref1.leadTimeUrl,
                    id: (ref2 = res.data[0]) === null || ref2 === void 0 ? void 0 : ref2.id,
                    leadTime_b: true,
                    pageTitle_s: (ref3 = res === null || res === void 0 ? void 0 : res.data[0]) === null || ref3 === void 0 ? void 0 : ref3["jcr:description"],
                    title_s: (ref4 = res === null || res === void 0 ? void 0 : res.data[0]) === null || ref4 === void 0 ? void 0 : ref4["page-description-content"]
                };
                setLeadTimeData(leadTimeData);
            }
        }).catch((err)=>{
            setLeadTimeData(null);
            console.error("Failed to get compare attributes JSON file", err);
        });
    }, []);
    (0,react.useEffect)(()=>{
        var ref, ref1;
        const fullcatalogResponse = searchResponse === null || searchResponse === void 0 ? void 0 : (ref = searchResponse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.fusion) === null || ref1 === void 0 ? void 0 : ref1.full_catalog_Response;
        if (fullcatalogResponse === null || fullcatalogResponse === void 0 ? void 0 : fullcatalogResponse.length) {
            if (fullcatalogResponse[0]["Brand_ss"][0] === "Sterling") {
                setIsSterling(true);
            }
        } else {
            setIsSterling(false);
        }
    }, [
        searchResponse
    ]);
    (0,react.useEffect)(()=>{
        if (general) {
            if ((searchKeyword === null || searchKeyword === void 0 ? void 0 : searchKeyword.length) > 2 && isInitialLoad) {
                var ref, ref1;
                (ref1 = getResults(searchKeyword, general === null || general === void 0 ? void 0 : (ref = general.brandName) === null || ref === void 0 ? void 0 : ref.toLowerCase())) === null || ref1 === void 0 ? void 0 : ref1.catch(()=>{});
                setSearchMainKeyword(searchKeyword);
                (0,helper/* removeSearchQueryParams */.FvC)();
                setIsInitialLoad(false);
            } else {
                debounceAndFetch(searchKeyword);
            }
        }
    }, [
        searchKeyword,
        tagDebug,
        general
    ]);
    const addSearchAnalytics = (params)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        const { total , errorMessage , status , autoSearch , keyword ="" , tabCountObj ={} , isSterlingTemp , searchCountIncreased =true  } = params;
        const action = autoSearch ? "cmp:click" : params === null || params === void 0 ? void 0 : params.action;
        const { productTabCount , helpTabCount , resourceTabCount , technicalTabCount , inspireTabCount , partTabCount  } = tabCountObj;
        const currDate = new Date();
        const eventInfo = {
            searchCount: (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("searches")) ? Number(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("searches")) + (searchCountIncreased ? 1 : 0) : 1,
            searchResult: isSterlingTemp ? "".concat(productTabCount) : total,
            searchResultCategory: isSterlingTemp ? "products>".concat(productTabCount) : "products>".concat(productTabCount, "|parts>").concat(partTabCount, "|inspiration>").concat(inspireTabCount, "|technical>").concat(technicalTabCount, "|resources>").concat(resourceTabCount, "|help>").concat(helpTabCount),
            internalLinkName: "search",
            internalLinkPosition: "search results:search",
            internalLinkType: autoSearch ? "search:automatic search" : "search results:search:navigation",
            searchTerm: keyword.length ? keyword : searchKeyword,
            searchSuggestedTerm: "n/a",
            eventAction: "search:search box:".concat(autoSearch ? "automatic " : "", "search"),
            eventName: "search:search box:".concat(autoSearch ? "automatic " : "", "search"),
            eventType: "navigation",
            clickInternalLinks: "true",
            internalLinkURL: action === "cmp:show" ? "n/a" : window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href,
            internalZoneName: "search:search box",
            eventMsg: errorMessage || "n/a",
            eventStatus: status === "success" ? "success" : "failure",
            pageName: "search result",
            pageURL: window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.href,
            referrer: (document === null || document === void 0 ? void 0 : document.referrer) || "n/a",
            previousPage: (document === null || document === void 0 ? void 0 : document.referrer) || "n/a",
            timeStamp: ((ref2 = currDate === null || currDate === void 0 ? void 0 : currDate.toISOString()) === null || ref2 === void 0 ? void 0 : ref2.split("T")[0]) + " " + ((ref3 = currDate === null || currDate === void 0 ? void 0 : currDate.toTimeString()) === null || ref3 === void 0 ? void 0 : ref3.split(" ")[0]),
            mktgCampaign: "n/a",
            contentType: general === null || general === void 0 ? void 0 : (ref4 = general.brandName) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase(),
            internalLinkZoneName: "search:search box"
        };
        sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem("searches", eventInfo === null || eventInfo === void 0 ? void 0 : eventInfo.searchCount);
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = action === "cmp:show" ? window === null || window === void 0 ? void 0 : window.pageObj : getState && getState("page") || {};
        const dtLayerObj = {
            event: action,
            page
        };
        if (action === "cmp:show" || action === "cmp:click") {
            dtLayerObj.eventInfo = eventInfo;
        }
        window === null || window === void 0 ? void 0 : (ref5 = window.adobeDataLayer) === null || ref5 === void 0 ? void 0 : ref5.push({
            ...dtLayerObj
        });
    };
    const debounceAndFetch = (0,react.useCallback)(debounce_default()((key)=>{
        if ((key === null || key === void 0 ? void 0 : key.length) > 2) {
            var ref, ref1;
            (ref1 = getResults(key, general === null || general === void 0 ? void 0 : (ref = general.brandName) === null || ref === void 0 ? void 0 : ref.toLowerCase())) === null || ref1 === void 0 ? void 0 : ref1.catch(()=>{});
            setSearchMainKeyword(key);
            (0,helper/* removeSearchQueryParams */.FvC)();
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }, 2000), [
        general === null || general === void 0 ? void 0 : (ref = general.brandName) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
        tagDebug
    ]);
    const handleSearch = (keyword, clear, tagger)=>{
        setSearchKeyword(keyword);
        setTagDebug(!tagger);
        setDebounceInProgress(true);
        if ((keyword === null || keyword === void 0 ? void 0 : keyword.length) === 0) {
            setTotal(0);
            setLoadPopularSearch(true);
        }
    };
    const handleSearchEnter = ()=>{
        if (debounceInProgress || loading) {
            setSearchClickEvent(true);
        } else {
            // this means no any requests are in progress. just add click event directly
            addSearchAnalytics({
                action: "cmp:click",
                status: "success",
                total: total,
                autoSearch: false
            });
        }
    };
    const setUrlParam = (keyword)=>{
        if (keyword) {
            var ref, ref1, ref2;
            const url = new URL(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
            const searchParams = url === null || url === void 0 ? void 0 : url.searchParams;
            let urlSearch = "?" + (searchParams === null || searchParams === void 0 ? void 0 : searchParams.toString());
            if (searchParams.get("keyword") !== keyword) {
                urlSearch = "?keyword=".concat(encodeURIComponent(keyword));
            }
            window === null || window === void 0 ? void 0 : (ref1 = window.history) === null || ref1 === void 0 ? void 0 : ref1.replaceState(window === null || window === void 0 ? void 0 : (ref2 = window.location) === null || ref2 === void 0 ? void 0 : ref2.pathname, document === null || document === void 0 ? void 0 : document.title, urlSearch);
        }
    };
    const getResults = function(keyword) {
        let brandNameVal = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "kohler";
        const { disableParts  } = staticTexts;
        return new Promise((resolve, reject)=>{
            var ref;
            setLoading(true);
            setDebounceInProgress(false);
            setLoadPopularSearch(false);
            let params = {
                q: keyword,
                rows: 1,
                "lw.tagger.debug": tagDebug,
                collections: brandNameVal,
                displaytype: "search"
            };
            if (isFromServicePart) {
                params = {
                    q: keyword,
                    rows: 1,
                    "lw.tagger.debug": tagDebug,
                    collections: brandNameVal,
                    service: true,
                    displaytype: "search"
                };
            }
            (ref = Promise.all([
                dispatch((0,searchSlice/* fetchSearchAllResults */.w$)({
                    ...params
                }))
            ]).then((resp)=>{
                var ref, ref1, ref2, ref3, ref4, ref5, ref6;
                const firstResponse = resp[0];
                const firstRespPayload = firstResponse === null || firstResponse === void 0 ? void 0 : firstResponse.payload;
                const firstRespFusion = firstRespPayload === null || firstRespPayload === void 0 ? void 0 : firstRespPayload.fusion;
                const fullCatalogResponse = firstRespFusion === null || firstRespFusion === void 0 ? void 0 : firstRespFusion.full_catalog_Response;
                let isSterlingTemp = false;
                if (fullCatalogResponse === null || fullCatalogResponse === void 0 ? void 0 : fullCatalogResponse.length) {
                    if (fullCatalogResponse[0]["Brand_ss"][0] === "Sterling") {
                        isSterlingTemp = true;
                        setIsSterling(true);
                    }
                }
                const isShowEvent = (0,helper/* isShowAnalyticsEventLoaded */.xJ2)();
                const isClickEvent = searchClickEvent;
                if (((ref = resp[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.payload) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fusion) === null || ref2 === void 0 ? void 0 : ref2.redirect) && ((ref3 = resp[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.payload) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.fusion) === null || ref5 === void 0 ? void 0 : ref5.redirect[0])) {
                    var ref7, ref8, ref9;
                    window.location.href = (ref7 = resp[0]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.payload) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fusion) === null || ref9 === void 0 ? void 0 : ref9.redirect[0];
                    addSearchAnalytics({
                        action: isClickEvent ? "cmp:click" : "cmp:show",
                        status: "success",
                        total: 1,
                        autoSearch: !isClickEvent && isShowEvent
                    });
                    resolve();
                } else if ((ref6 = resp[0]) === null || ref6 === void 0 ? void 0 : ref6.payload) {
                    var ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20;
                    (0,helper/* addToRecentSearch */.R$3)(keyword);
                    let groups = [
                        {
                            key: "products",
                            count: get_default()((ref10 = resp[0]) === null || ref10 === void 0 ? void 0 : ref10.payload, "facet_counts.facet_fields.Products[1]", 0)
                        },
                        {
                            key: "technical",
                            count: get_default()((ref11 = resp[0]) === null || ref11 === void 0 ? void 0 : ref11.payload, "facet_counts.facet_fields.Technical[1]", 0)
                        },
                        {
                            key: "inspiration",
                            count: get_default()((ref12 = resp[0]) === null || ref12 === void 0 ? void 0 : ref12.payload, "facet_counts.facet_fields.Inspiration[1]", 0)
                        },
                        {
                            key: "resource",
                            count: get_default()((ref13 = resp[0]) === null || ref13 === void 0 ? void 0 : ref13.payload, "facet_counts.facet_fields.Resource[1]", 0)
                        },
                        {
                            key: "help",
                            count: get_default()((ref14 = resp[0]) === null || ref14 === void 0 ? void 0 : ref14.payload, "facet_counts.facet_fields.Help[1]", 0)
                        }
                    ];
                    if (disableParts || !isSterling) {
                        groups = groups === null || groups === void 0 ? void 0 : groups.filter((arr)=>{
                            return (arr === null || arr === void 0 ? void 0 : arr.key) !== "parts";
                        });
                    }
                    // Calculating the total results
                    let total = 0;
                    const selected = groups === null || groups === void 0 ? void 0 : groups.find((group)=>{
                        return (group === null || group === void 0 ? void 0 : group.count) > 0;
                    });
                    if ((ref15 = resp[0]) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.payload) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.fusion) === null || ref17 === void 0 ? void 0 : ref17.exactMatch) {
                        var ref21, ref22, ref23;
                        total = (ref21 = resp[0]) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.payload) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.response) === null || ref23 === void 0 ? void 0 : ref23.numFound;
                    } else {
                        groups === null || groups === void 0 ? void 0 : groups.map((group)=>{
                            return total += group === null || group === void 0 ? void 0 : group.count;
                        });
                    }
                    if (total === 0) {
                        setLoadPopularSearch(true);
                    }
                    setLoading(false);
                    // setData(resp[0].payload)
                    if (total > 0) setTotal(1 + total);
                    else setTotal(total);
                    setSelected(selected);
                    setExactMatch((ref18 = resp[0]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.payload) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.fusion) === null || ref20 === void 0 ? void 0 : ref20.exactMatch);
                    setSearchClickEvent(false);
                    setUrlParam(keyword);
                    const productTabCount = get_default()(resp[0].payload, "facet_counts.facet_fields.Products[1]", 0);
                    const inspireTabCount = get_default()(resp[0].payload, "facet_counts.facet_fields.Inspiration[1]", 0);
                    const technicalTabCount = get_default()(resp[0].payload, "facet_counts.facet_fields.Technical[1]", 0);
                    const resourceTabCount = get_default()(resp[0].payload, "facet_counts.facet_fields.Resource[1]", 0);
                    const helpTabCount = get_default()(resp[0].payload, "facet_counts.facet_fields.Help[1]", 0);
                    const partTabCount = 0;
                    const tabCountObj = {
                        productTabCount: isSterlingTemp ? 1 : productTabCount,
                        helpTabCount,
                        resourceTabCount,
                        technicalTabCount,
                        inspireTabCount,
                        partTabCount
                    };
                    addSearchAnalytics({
                        action: isClickEvent ? "cmp:click" : "cmp:show",
                        status: "success",
                        total,
                        autoSearch: !isClickEvent && isShowEvent,
                        keyword: keyword,
                        tabCountObj,
                        isSterlingTemp
                    });
                    // if the url changes on subsequent searches then log a cmp:show as well
                    if (pageLoadedRef.current) {
                        addSearchAnalytics({
                            action: "cmp:show",
                            status: "success",
                            total,
                            autoSearch: false,
                            keyword: keyword,
                            tabCountObj,
                            isSterlingTemp,
                            searchCountIncreased: false
                        });
                    } else {
                        pageLoadedRef.current = true;
                    }
                    resolve();
                }
            })) === null || ref === void 0 ? void 0 : ref.catch((err)=>{
                var ref;
                // eslint-disable-next-line no-console
                console.log("Error occured while fetching Search data", err);
                const isShowEvent = (0,helper/* isShowAnalyticsEventLoaded */.xJ2)();
                const isClickEvent = searchClickEvent;
                setLoading(false);
                setSearchClickEvent(false);
                setLoadPopularSearch(true);
                addSearchAnalytics({
                    action: isClickEvent ? "cmp:click" : "cmp:show",
                    errorMessage: staticTexts === null || staticTexts === void 0 ? void 0 : (ref = staticTexts.noResults) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                    status: "failure",
                    total: 0,
                    autoSearch: !isClickEvent && isShowEvent
                });
                reject(new Error("something bad happened"));
            });
        });
    };
    const staticData = staticTexts;
    const { disableParts  } = staticData;
    const tabList = [];
    if (((ref1 = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Products", [])) === null || ref1 === void 0 ? void 0 : ref1.length) > 1) {
        var ref2;
        const count = isSterling ? 1 : get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Products[1]", 0);
        tabList === null || tabList === void 0 ? void 0 : tabList.push({
            id: "Products",
            title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.products,
            count: count,
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductsTab, {
                staticTexts: staticTexts,
                page: "search",
                type: "Products",
                searchKeyword: searchMainKeyword,
                totalSearchResults: isSterling ? 1 : total,
                count: count,
                currencySign: info === null || info === void 0 ? void 0 : info.currencySign,
                onSearch: handleSearch,
                query: 'Products:("ct")',
                lwAppName: general === null || general === void 0 ? void 0 : general.lwAppName,
                componentProps: componentProp,
                presetConfigs: props === null || props === void 0 ? void 0 : (ref2 = props.data) === null || ref2 === void 0 ? void 0 : ref2.presetConfigs,
                marketParamValues: general === null || general === void 0 ? void 0 : general.marketParamValues,
                isSterling: isSterling,
                sterlingData: isSterling && searchResponse.data.fusion.full_catalog_Response,
                showSterlingButton: true,
                plpBadge: plpBadge
            }, "Products")
        });
    }
    if (!isSterling) {
        var ref3, ref4, ref5, ref6;
        if (get_default()(partsData, "response.numFound", 0) > 0 && !disableParts && (general === null || general === void 0 ? void 0 : general.lwAppName.toLowerCase()) !== "annsacks") {
            var ref7;
            const count1 = get_default()(partsData, "response.numFound", 0);
            tabList === null || tabList === void 0 ? void 0 : tabList.push({
                id: "Parts",
                title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.parts,
                count: count1,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ProductsTab, {
                    staticTexts: staticTexts,
                    page: "search",
                    type: "Parts",
                    count: count1,
                    searchKeyword: searchMainKeyword,
                    totalSearchResults: total,
                    currencySign: info === null || info === void 0 ? void 0 : info.currencySign,
                    onSearch: handleSearch,
                    productsPerPage: productsPerPage,
                    componentProps: componentProp,
                    presetConfigs: props === null || props === void 0 ? void 0 : (ref7 = props.data) === null || ref7 === void 0 ? void 0 : ref7.presetConfigs,
                    marketParamValues: general === null || general === void 0 ? void 0 : general.marketParamValues,
                    isSterling: isSterling,
                    sterlingData: isSterling && searchResponse.data.fusion.full_catalog_Response,
                    lwAppName: general === null || general === void 0 ? void 0 : general.lwAppName
                }, "Parts")
            });
        }
        if (((ref3 = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Inspiration", [])) === null || ref3 === void 0 ? void 0 : ref3.length) > 1) {
            const count2 = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Inspiration[1]", 0);
            tabList === null || tabList === void 0 ? void 0 : tabList.push({
                id: "Inspiration",
                title: staticTexts.inspiration,
                count: count2,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationTab/* default */.Z, {
                    page: "search",
                    type: "Inspiration",
                    searchKeyword: searchMainKeyword,
                    totalResults: count2,
                    totalSearchResults: total,
                    displayShare: true,
                    displayPrint: true,
                    onSearch: handleSearch,
                    productsPerPage: productsPerPage,
                    fquery: 'Inspiration:("Inspiration")',
                    staticTexts: staticTexts,
                    knowledgeArticleUrl: info === null || info === void 0 ? void 0 : info.knowledgeArticleUrl,
                    marketParamValues: general === null || general === void 0 ? void 0 : general.marketParamValues,
                    lwAppName: general === null || general === void 0 ? void 0 : general.lwAppName,
                    profileName: "profile_".concat(general === null || general === void 0 ? void 0 : general.lwAppName, "_Search")
                }, "Inspiration")
            });
        }
        if (((ref4 = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Technical", [])) === null || ref4 === void 0 ? void 0 : ref4.length) > 1) {
            const count3 = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Technical[1]", 0);
            tabList === null || tabList === void 0 ? void 0 : tabList.push({
                id: "Technical",
                title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.technical,
                count: count3,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_TechnicalTab, {
                    page: "search",
                    staticTexts: staticTexts,
                    type: "Technical",
                    searchKeyword: searchMainKeyword,
                    totalSearchResults: total,
                    displayShare: true,
                    displayPrint: true,
                    onSearch: handleSearch,
                    productsPerPage: productsPerPage,
                    totalResults: total,
                    marketParamValues: general === null || general === void 0 ? void 0 : general.marketParamValues
                }, "Technical")
            });
        }
        if (((ref5 = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Resource", [])) === null || ref5 === void 0 ? void 0 : ref5.length) >= 0) {
            const count4 = 1 + get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Resource[1]", 0);
            tabList === null || tabList === void 0 ? void 0 : tabList.push({
                id: "Resources",
                title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.resource,
                count: count4,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationTab/* default */.Z, {
                    page: "search",
                    type: "Resources",
                    searchKeyword: searchMainKeyword,
                    totalResults: total,
                    leadTimeData: leadTimeData,
                    totalSearchResults: total,
                    displayShare: true,
                    displayPrint: true,
                    onSearch: handleSearch,
                    productsPerPage: productsPerPage,
                    fquery: 'Resource:("Resource")',
                    staticTexts: staticTexts,
                    knowledgeArticleUrl: info.knowledgeArticleUrl,
                    lwAppName: general === null || general === void 0 ? void 0 : general.lwAppName,
                    profileName: "profile_".concat(general === null || general === void 0 ? void 0 : general.lwAppName, "_Search")
                }, "Resources")
            });
        }
        if (((ref6 = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Help", [])) === null || ref6 === void 0 ? void 0 : ref6.length) > 1) {
            const count5 = get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "facet_counts.facet_fields.Help[1]", 0);
            tabList === null || tabList === void 0 ? void 0 : tabList.push({
                id: "Help",
                title: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.help,
                count: count5,
                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationTab/* default */.Z, {
                    page: "search",
                    staticTexts: staticTexts,
                    type: "Help",
                    searchKeyword: searchMainKeyword,
                    totalResults: count5,
                    onSearch: handleSearch,
                    productsPerPage: productsPerPage,
                    fquery: 'Help:("sf")',
                    knowledgeArticleUrl: info.knowledgeArticleUrl,
                    totalSearchResults: total,
                    displayShare: true,
                    displayPrint: true
                }, "Help")
            });
        }
    }
    let activeTab;
    const currentTab = (0,helper/* getParamFromUrl */.LjC)("tab") || "";
    if (currentTab) activeTab = tabList === null || tabList === void 0 ? void 0 : tabList.findIndex((tab)=>{
        return (tab === null || tab === void 0 ? void 0 : tab.id) === currentTab;
    });
    else {
        if (get_default()(searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data, "fusion.default_tab[0]", "")) {
            activeTab = tabList === null || tabList === void 0 ? void 0 : tabList.findIndex((tab)=>{
                var ref, ref1;
                return (tab === null || tab === void 0 ? void 0 : tab.id) === (searchResponse === null || searchResponse === void 0 ? void 0 : (ref = searchResponse.data) === null || ref === void 0 ? void 0 : (ref1 = ref.fusion) === null || ref1 === void 0 ? void 0 : ref1.default_tab[0]);
            });
        }
    }
    if (exactMatch) tabList === null || tabList === void 0 ? void 0 : tabList.forEach((tab, index)=>{
        if ((tab === null || tab === void 0 ? void 0 : tab.id) !== (selected === null || selected === void 0 ? void 0 : selected.key)) {
            tabList === null || tabList === void 0 ? void 0 : tabList.splice(1, index);
        }
    });
    if ((searchResponse === null || searchResponse === void 0 ? void 0 : searchResponse.data) || (searchKeyword === null || searchKeyword === void 0 ? void 0 : searchKeyword.length) < 3) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchView, {
                activeTabVal: activeTab,
                loading: loading,
                data: componentProp,
                staticTexts: staticTexts,
                totalResults: isSterling ? 1 : total,
                searchKeyword: searchKeyword,
                tabList: tabList,
                selected: selected,
                exactMatch: exactMatch,
                onSearch: handleSearch,
                brand: general === null || general === void 0 ? void 0 : general.brandName,
                handleSearchEnter: handleSearchEnter,
                staticData: staticData,
                loadPopularSearch: loadPopularSearch,
                searchResponse: searchResponse
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OuterSearchProgressive, {});
    }
};
/* harmony default export */ var Search = (SearchComponent);

// EXTERNAL MODULE: ./src/components/Default/BreadCrumb.jsx
var BreadCrumb = __webpack_require__(42053);
;// CONCATENATED MODULE: ./src/pages/search.jsx


















/**
 * renders home page
 * @return {JSX.Element}
 * @param {object} props The props.
 */ const search_Search = (props)=>{
    const { tmpData: data , headertmp: header , footertmp: footer , ip , adobeAnalytic , globalScript , footerScript , analyticsData , datalayerPageName , gbhDataLayerCustom  } = props;
    const dispatch = (0,es/* useDispatch */.I0)();
    const router = (0,next_router.useRouter)();
    const { cartUrl  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const { brandLogoImg , menu: { isOpen , mainCategoryActive , isRegionOpen , isAuthNavOpen  }  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    (0,react.useEffect)(()=>{
        if (ip) sessionStorage.setItem("true-ip", ip);
    }, [
        ip
    ]);
    (0,usePageAuth/* default */.Z)();
    const cartCount = (0,cart/* getCartCount */.c0)();
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const ariaLabel = (0,cart/* getAriaLabel */.Xw)(t, cartCount);
    (0,react.useEffect)(()=>{
        (0,helper/* getScriptsAndStyles */.csL)(footer);
    }, [
        footer
    ]);
    (0,react.useEffect)(()=>{
        (0,helper/* getAnalyticsScript */.Szq)(adobeAnalytic);
    }, [
        adobeAnalytic
    ]);
    (0,react.useEffect)(()=>{
        (0,helper/* getDataLayerObj */.C2G)(analyticsData);
    }, [
        analyticsData
    ]);
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* setDatalayerPageName */.dN)(datalayerPageName));
        dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(gbhDataLayerCustom));
        return ()=>{
            dispatch((0,genericSlice/* setDatalayerPageName */.dN)(""));
            dispatch((0,genericSlice/* setGbhDataLayerCustom */.ks)(""));
        };
    }, []);
    const toggleMenu = ()=>{
        if (isOpen) {
            dispatch((0,genericSlice/* closeMenu */.Wj)());
            dispatch((0,genericSlice/* setAuthNav */.AT)(false));
        } else {
            dispatch((0,genericSlice/* openMenu */.qn)());
        }
    };
    const redirect = ()=>{
        router.push("".concat(cartUrl));
    };
    const eventHandler = {
        store: {
            brandLogoImg: brandLogoImg,
            isOpen,
            mainCategoryActive,
            isRegionOpen,
            isAuthNavOpen,
            cartCount,
            ariaLabel,
            cartUrl
        },
        callbacks: {
            setBrandLogoImg: (path)=>{
                dispatch((0,genericSlice/* setBrandLogoImg */.XY)(path));
            },
            closeMenu: ()=>{
                dispatch((0,genericSlice/* closeMenu */.Wj)());
            },
            setMainCategory: (payload)=>{
                dispatch((0,genericSlice/* setActiveMainCategory */.X7)(payload));
            },
            toggleMenu: ()=>{
                toggleMenu();
            },
            setRegionNav: (active)=>{
                dispatch((0,genericSlice/* setRegionNav */.qX)(active));
            },
            setAuthNav: (active)=>{
                dispatch((0,genericSlice/* setAuthNav */.AT)(active));
            },
            setGlobalScripts: (item)=>{
                dispatch((0,genericSlice/* setGlobalScripts */.n8)(item));
            },
            setGlobalStyles: (item)=>{
                dispatch((0,genericSlice/* setGlobalStyles */.cw)(item));
            },
            onClick: ()=>{
                redirect();
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageLayout/* default */.Z, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageHeader/* default */.Z, {
            header: header,
            title: data.title,
            globalScripting: globalScript
        }),
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalPageFooter/* default */.Z, {
            footer: footer,
            footerScripting: footerScript
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: data.id,
            className: data.cssClassNames,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AemGrid/* default */.Z, {
                data: data,
                count: 0,
                eventHandler: eventHandler,
                breadCrumb: (data)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumb["default"], {
                        data: data
                    }),
                searchComponent: (data, eventHandler)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {
                        data: data,
                        eventHandler: eventHandler,
                        header: header
                    }),
                searchFiller: ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(v1_OuterSearchProgressive, {
                        data: data
                    })
            })
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var search = (search_Search);


/***/ }),

/***/ 42680:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchViewStyleWrapper":"SearchView_searchViewStyleWrapper__m07Pg"};

/***/ }),

/***/ 25043:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ g; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var h = Object.defineProperty;
var u = (n, t, e) => t in n ? h(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var c = (n, t, e) => (u(n, typeof t != "symbol" ? t + "" : t, e), e);

const p = (n, t) => typeof getComputedStyle < "u" ? getComputedStyle(n, null).getPropertyValue(t) : n.style.getPropertyValue(t), y = (n) => p(n, "overflow") + p(n, "overflow-y") + p(n, "overflow-x"), w = (n) => {
  if (!(n instanceof HTMLElement))
    return window;
  let t = n;
  for (; t && !(t === document.body || t === document.documentElement || !t.parentNode); ) {
    if (/(scroll|auto)/.test(y(t)))
      return t;
    t = t.parentNode;
  }
  return window;
};
class g extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(e) {
    super(e);
    c(this, "elementObserver");
    c(this, "wrapper");
    c(this, "lazyLoadHandler", (e) => {
      var o, i;
      const {
        onContentVisible: s
      } = this.props, [r] = e, {
        isIntersecting: l
      } = r;
      if (l) {
        this.setState({
          visible: !0
        }, () => {
          s && s();
        });
        const a = (o = this.wrapper) == null ? void 0 : o.current;
        a && a instanceof HTMLElement && ((i = this.elementObserver) == null || i.unobserve(a));
      }
    });
    this.elementObserver = null, this.wrapper = react__WEBPACK_IMPORTED_MODULE_0__.createRef(), this.state = {
      visible: !1
    };
  }
  componentDidMount() {
    var o;
    this.getEventNode();
    const {
      offset: e,
      threshold: s
    } = this.props, r = {
      rootMargin: typeof e == "number" ? `${e}px` : e || "0px",
      threshold: s || 0
    };
    this.elementObserver = new IntersectionObserver(this.lazyLoadHandler, r);
    const l = (o = this.wrapper) == null ? void 0 : o.current;
    l instanceof HTMLElement && this.elementObserver.observe(l);
  }
  shouldComponentUpdate(e, s) {
    return s.visible;
  }
  componentWillUnmount() {
    var s, r;
    const e = (s = this.wrapper) == null ? void 0 : s.current;
    e && e instanceof HTMLElement && ((r = this.elementObserver) == null || r.unobserve(e));
  }
  getEventNode() {
    var e;
    return w((e = this.wrapper) == null ? void 0 : e.current);
  }
  render() {
    const {
      children: e,
      className: s,
      height: r,
      width: l,
      elementType: o
    } = this.props, {
      visible: i
    } = this.state, a = {
      height: r,
      width: l
    }, d = `LazyLoad${i ? " is-visible" : ""}${s ? ` ${s}` : ""}`;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(o || "div", {
      className: d,
      style: a,
      ref: this.wrapper
    }, i && react__WEBPACK_IMPORTED_MODULE_0__.Children.only(e));
  }
}
c(g, "defaultProps", {
  elementType: "div",
  className: "",
  offset: 0,
  threshold: 0,
  width: null,
  onContentVisible: null,
  height: null
});



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,6351,6342,4432,7333,4904,361,9851,5921,4204,4382,4547,5531,1304,1934,9450,7866,3236,3707,9774,2888,179], function() { return __webpack_exec__(32252); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);